/**
 * Wraps a rendered date/time label; on hover shows the same instant converted to the
 * viewer's own browser-local timezone, including its abbreviation (e.g. "6 Jun 2026,
 * 4:00 PM EST"). Reusable anywhere a date/time is rendered in an explicit (e.g. template)
 * timezone rather than the viewer's own.
 */
import { Tooltip } from '@material-ui/core';
import React from 'react';
import { guessCurrentTimezone, Timestamp, toMoment } from '../../services/time';

export const DateTimeHoverTooltip: React.FC<{
  at: Timestamp;
  /** When set, shows `at` and `rangeEnd` as a start–end pair on two lines (e.g. a task's start and deadline) instead of a single instant. */
  rangeEnd?: Timestamp;
  children: React.ReactNode;
  className?: string;
}> = ({ at, rangeEnd, children, className }) => {
  const userTz = guessCurrentTimezone();
  const format = (ts: Timestamp) => toMoment(ts).tz(userTz).format('D MMM YYYY, h:mm A z');
  const title = rangeEnd ? (
    <>
      {format(at)} –<br />
      {format(rangeEnd)}
    </>
  ) : (
    format(at)
  );
  return (
    <Tooltip title={title}>
      <span className={className}>{children}</span>
    </Tooltip>
  );
};
